(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/limit-coverage-warning.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/limit-coverage-warning.js');
'use strict';

const Paper = svs.ui.ReactPaper;
const capitalizeString = svs.utils.format.capitalize;
const LimitCoverageWarning = _ref => {
  let {
    product,
    amount,
    period
  } = _ref;
  return React.createElement("div", {
    className: "u-flex"
  }, React.createElement(Paper, {
    branding: "tur",
    className: "padding-1 set-limits-paper"
  }, React.createElement("div", null, "Ditt spel p\xE5", ' ', capitalizeString(product, true), ' ', "kostar", ' ', amount, ' ', "kr! Med dina valda gr\xE4nser kommer du inte ha r\xE5d att l\xE4gga n\xE5gra fler spel", ' ', period, ".")));
};
svs.accountservicesReact.gameLimitDepositsForm.LimitCoverageWarning = LimitCoverageWarning;

 })(window);